import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
const Loader = () => {
  return <ClipLoader color="#8dbe22" loading={true} css="" size={100} />;
};

export default Loader;
